module.exports = __webpack_public_path__ + "media/images/img/tag_company/dena_tag-546c2df66c2c28d4231070996e00d665.png";